module["exports"] = [
  "Slovensko"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/sk/address/default_country.js
// module id = 1542
// module chunks = 0